export default __webpack_public_path__ + "static/media/Angelica 9781408316887.39392f5e.jpg";